import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-matdialog',
	templateUrl:'./MatDialogPage.html',
	styles: [],
	styleUrls:['./MatDialogPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class MatDialogPage
{
	mdContent_250 = `\`\`\`java
import com.jwebmp.plugins.angular.material.dialog.MatDialog;
\`\`\``;
	mdContent_251 = `\`\`\`java
MatDialog()
\`\`\``;
	mdContent_252 = `\`\`\`java
MatDialog&lt;?&gt; dialog = new MatDialog&lt;&gt;();
dialog.setWidth("500px");
dialog.setDisableClose(true);
dialog.add(new Paragraph&lt;&gt;().setText("Dialog content"));
// Dialog is opened programmatically via MatDialogService
\`\`\``;
}
